import isEqual from 'lodash/isEqual';

import { iaRa, mString } from 'lib/helpers/utility';

import ServiceActions from '../components/ServiceActions';

export const scheduleOfFeesMainColumns = [
  {
    field: 'name',
    headerName: 'Name',
    sortable: false,
    flex: 1,
    headerCheckboxSelection: true,
    checkboxSelection: (params) => !params.node.group
  },
  {
    field: 'professionGroups',
    headerName: 'Specialty',
    sortable: false,
    cellRenderer: ({ value }) =>
      iaRa(value)
        .map((v) => v.name)
        .join(', '),
    flex: 1
  },
  {
    field: 'total_cost_cents',
    headerName: 'Self pay',
    cellRenderer: ({ value }) => mString(value),
    sortable: false,
    maxWidth: 120
  },
  {
    field: 'par_amount',
    headerName: 'Allowable amount',
    cellRenderer: ({ value }) => mString(value),
    maxWidth: 150
  },
  {
    field: 'standard_charge',
    headerName: 'Standard',
    cellRenderer: ({ value }) => mString(value),
    sortable: false,
    maxWidth: 120
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellRenderer: ServiceActions,
    maxWidth: 100,
    minWidth: 36,
    resizable: false,
    sortable: false,
    pinned: 'right'
  }
];

/**
 * @param {Object} updatedService - The updated service object.
 * @param {Object} service - The original service object.
 * @returns {Object} - An object containing the changes.
 */
export const getServiceChanges = (updatedService, service) => {
  const serviceChanges = {};
  for (const key in updatedService) {
    if (!isEqual(updatedService[key], service[key])) {
      serviceChanges[key] = updatedService[key];
    }
  }
  return serviceChanges;
};
